import { RiskQuestions } from 'src/app/common/modules/dialog-pop-ups/components/analytics-information-dialog/analytics-information-dialog.component';
import { IAssets } from 'src/app/models/assets';
import {
  IIncidents,
  IncidentBreakdownGraph,
  IncidentTimelineGrpah,
} from 'src/app/models/incident';
import { IPostComments } from 'src/app/models/notice-board';
import { IProperty } from 'src/app/models/property';
import { IRequest, IRespond } from 'src/app/models/requests';
import {
  IRiskGraph,
  IRiskQuestions,
  IRiskSingleGraph,
} from 'src/app/models/riskProfile';
import { ComplaintsTickets } from 'src/app/models/tickets';
import { UserRegDetails } from 'src/app/models/user';
import { IncidentPieGraph } from 'src/app/state-management/states/aumye-dashboard.state';
import { v4 as uuidv4 } from 'uuid';

const incidentNames: string[] = [
  'Unmonitored logs/activity',
  'Unverified Vehicle',
  'Unverified Visitor',
  'Unidentified Person',
  'Abandoned Object',
  'Unauthorised/Intruded Entry',
  'Theft/Pilferage',
  'Device Offline',
  'Device Faulty',
  'Loss/Damage of Property',
  'Suspicious Behaviour',
  'Unattended Incident',
  'Fire',
  'Riot/Protest',
  'Possible Crime',
  'Plumbing Incident',
  'Electricity Incident',
  'Communication Failure',
  'Infrastructure Damage',
  'Over utilised Energy',
  'Under utilised Energy',
  'Unattended SoS',
  'Custom Incident',
  'Unmonitored Asset',
  'Unsettled Claims',
  'Total Claims',
];
const numberPlates: string[] = [
  'UP32KW8888',
  'KA03AB1234',
  'MH12XY6789',
  'DL10AZ4567',
  'TN09BC2345',
  'AP16DE7890',
  'GJ05FG3456',
  'RJ27HI9012',
  'UP14JK6789',
  'WB20LM3456',
  'HR26NO1234',
  'MP09PQ5678',
  'OR02RS7890',
  'KL07TU4567',
  'PB08VW9012',
  'CG04XY1234',
  'KA51ER1122',
  'MH14GH4433',
  'DL03BV7722',
  'TN10CD8822',
  'AP09EF9900',
  'GJ06GH5566',
  'RJ31IJ3300',
  'UP21KL7788',
  'WB23MN1234',
  'HR29OP4567',
  'MP11QR6789',
  'OR07ST1234',
  'KL11UV5678',
  'PB05WX2345',
  'CG02YZ7890',
];
export const locations: ILocation[] = [
  {
    label: 'Jammu, Jammu and Kashmir, India',
    countryCode: 'IND',
    countryName: 'India',
    stateCode: 'JK',
    state: 'Jammu and Kashmir',
    county: 'Jammu',
    postalCode: '180001',
    city: 'Jammu',
    lat: 32.7266,
    lng: 74.857,
  },
  {
    label: 'Srinagar, Jammu and Kashmir, India',
    countryCode: 'IND',
    countryName: 'India',
    stateCode: 'JK',
    state: 'Jammu and Kashmir',
    county: 'Srinagar',
    postalCode: '190001',
    city: 'Srinagar',
    lat: 34.0836,
    lng: 74.7973,
  },
  {
    label: 'Katra, Jammu and Kashmir, India',
    countryCode: 'IND',
    countryName: 'India',
    stateCode: 'JK',
    state: 'Jammu and Kashmir',
    county: 'Reasi',
    postalCode: '182320',
    city: 'Katra',
    lat: 32.9833,
    lng: 74.9511,
  },
  {
    label: 'Udhampur, Jammu and Kashmir, India',
    countryCode: 'IND',
    countryName: 'India',
    stateCode: 'JK',
    state: 'Jammu and Kashmir',
    county: 'Udhampur',
    postalCode: '182101',
    city: 'Udhampur',
    lat: 32.9333,
    lng: 75.1333,
  },
  {
    label: 'Rajouri, Jammu and Kashmir, India',
    countryCode: 'IND',
    countryName: 'India',
    stateCode: 'JK',
    state: 'Jammu and Kashmir',
    county: 'Rajouri',
    postalCode: '185131',
    city: 'Rajouri',
    lat: 33.37,
    lng: 74.36,
  },
  {
    label: 'Poonch, Jammu and Kashmir, India',
    countryCode: 'IND',
    countryName: 'India',
    stateCode: 'JK',
    state: 'Jammu and Kashmir',
    county: 'Poonch',
    postalCode: '185101',
    city: 'Poonch',
    lat: 33.7593,
    lng: 73.9954,
  },
  {
    label: 'Doda, Jammu and Kashmir, India',
    countryCode: 'IND',
    countryName: 'India',
    stateCode: 'JK',
    state: 'Jammu and Kashmir',
    county: 'Doda',
    postalCode: '182201',
    city: 'Doda',
    lat: 33.1833,
    lng: 75.6,
  },
  {
    label: 'Bhaderwah, Jammu and Kashmir, India',
    countryCode: 'IND',
    countryName: 'India',
    stateCode: 'JK',
    state: 'Jammu and Kashmir',
    county: 'Doda',
    postalCode: '182222',
    city: 'Bhaderwah',
    lat: 32.9731,
    lng: 75.6165,
  },
  {
    label: 'Billawar, Jammu and Kashmir, India',
    countryCode: 'IND',
    countryName: 'India',
    stateCode: 'JK',
    state: 'Jammu and Kashmir',
    county: 'Kathua',
    postalCode: '184202',
    city: 'Billawar',
    lat: 32.4361,
    lng: 75.6612,
  },
  {
    label: 'Nowshera, Jammu and Kashmir, India',
    countryCode: 'IND',
    countryName: 'India',
    stateCode: 'JK',
    state: 'Jammu and Kashmir',
    county: 'Rajouri',
    postalCode: '185151',
    city: 'Nowshera',
    lat: 33.3392,
    lng: 74.2369,
  },
  {
    label: 'Kishtwar, Jammu and Kashmir, India',
    countryCode: 'IND',
    countryName: 'India',
    stateCode: 'JK',
    state: 'Jammu and Kashmir',
    county: 'Kishtwar',
    postalCode: '182204',
    city: 'Kishtwar',
    lat: 33.5469,
    lng: 75.74,
  },
  {
    label: 'Batote, Jammu and Kashmir, India',
    countryCode: 'IND',
    countryName: 'India',
    stateCode: 'JK',
    state: 'Jammu and Kashmir',
    county: 'Ramban',
    postalCode: '182142',
    city: 'Batote',
    lat: 33.1167,
    lng: 75.3917,
  },
  {
    label: 'Akhnoor, Jammu and Kashmir, India',
    countryCode: 'IND',
    countryName: 'India',
    stateCode: 'JK',
    state: 'Jammu and Kashmir',
    county: 'Jammu',
    postalCode: '181201',
    city: 'Akhnoor',
    lat: 32.749,
    lng: 74.6237,
  },
  {
    label: 'Sunderbani, Jammu and Kashmir, India',
    countryCode: 'IND',
    countryName: 'India',
    stateCode: 'JK',
    state: 'Jammu and Kashmir',
    county: 'Rajouri',
    postalCode: '185151',
    city: 'Sunderbani',
    lat: 33.2913,
    lng: 74.4653,
  },
  {
    label: 'Mendhar, Jammu and Kashmir, India',
    countryCode: 'IND',
    countryName: 'India',
    stateCode: 'JK',
    state: 'Jammu and Kashmir',
    county: 'Poonch',
    postalCode: '185113',
    city: 'Mendhar',
    lat: 33.5389,
    lng: 73.9969,
  },
  {
    label: 'Bhagwa, Jammu and Kashmir, India',
    countryCode: 'IND',
    countryName: 'India',
    stateCode: 'JK',
    state: 'Jammu and Kashmir',
    county: 'Udhampur',
    postalCode: '182121',
    city: 'Bhagwa',
    lat: 32.9167,
    lng: 75.2833,
  },
  {
    label: 'Chhatral, Jammu and Kashmir, India',
    countryCode: 'IND',
    countryName: 'India',
    stateCode: 'JK',
    state: 'Jammu and Kashmir',
    county: 'Doda',
    postalCode: '182202',
    city: 'Chhatral',
    lat: 32.9385,
    lng: 75.5645,
  },
  {
    label: 'Chakwal, Jammu and Kashmir, India',
    countryCode: 'IND',
    countryName: 'India',
    stateCode: 'JK',
    state: 'Jammu and Kashmir',
    county: 'Rajouri',
    postalCode: '185152',
    city: 'Chakwal',
    lat: 33.3915,
    lng: 74.2894,
  },
  {
    label: 'Bhadarwah, Jammu and Kashmir, India',
    countryCode: 'IND',
    countryName: 'India',
    stateCode: 'JK',
    state: 'Jammu and Kashmir',
    county: 'Doda',
    postalCode: '182222',
    city: 'Bhadarwah',
    lat: 32.9756,
    lng: 75.6522,
  },
];
const assets: IAssets[] = [
  {
    propId: 'e75726ac-8cec-4493-a608-3bf5978bc14b',
    assetId: 'bb70db76-51b0-4758-a79c-4ed08f774d2b',
    assetName: 'Cabin',
    assetType: 'NETCAM',
    assetUrl: 'rtsp://admin:Admin@123@192.168.1.12',
    assetUrlPlaylist: 'https://rtsp.me/embed/EQeG2zFh/',
    assetLocation:
      '[{"label":"8 Rama Lane, Bhagwati Nagar-Ward No 23, Talab Tillo, Jammu 180002, India","countryCode":"IND","countryName":"India","stateCode":"JK","state":"Jammu & Kashmir","county":"Jammu","postalCode":"180002","city":"Jammu","lat":32.72916,"lng":74.83988}]',
    assetCreateDate: '2024-07-20T17:46:32.5',
    assetRemoveDate: null,
    computerVision: null,
    intrusion: null,
    peopleDetection: null,
    animalDetection: null,
    vehicleDetection: null,
    anpr: null,
    fire: null,
    faceRecognization: null,
    settingCreateDate: null,
    settingCreateDateBy: null,
    settingUpdateDate: null,
    settingUpdateBy: null,
    settingMode: null,
    assetFrame: null,
    frameHeight: null,
    frameWidth: null,
    assetFrameMobile: null,
    frameHeightMobile: null,
    frameWidthMobile: null,
  },
  {
    propId: 'e75726ac-8cec-4493-a608-3bf5978bc14b',
    assetId: '46d03e43-f7f9-46d9-8062-75d42d027c18',
    assetName: 'Stairs',
    assetType: 'NETCAM',
    assetUrl: 'rtsp://admin:Admin@123@192.168.1.11',
    assetUrlPlaylist: 'https://rtsp.me/embed/z7t4e2rh/',
    assetLocation:
      '[{"label":"Kathua Sub-District, Jammu & Kashmir, India","countryCode":"IND","countryName":"India","stateCode":"JK","state":"Jammu & Kashmir","county":"Kathua","postalCode":"184143","city":"Kathua Sub-District","lat":32.41237,"lng":75.47252}]',
    assetCreateDate: '2024-07-20T17:43:32.65',
    assetRemoveDate: null,
    computerVision: null,
    intrusion: null,
    peopleDetection: null,
    animalDetection: null,
    vehicleDetection: null,
    anpr: null,
    fire: null,
    faceRecognization: null,
    settingCreateDate: null,
    settingCreateDateBy: null,
    settingUpdateDate: null,
    settingUpdateBy: null,
    settingMode: null,
    assetFrame: null,
    frameHeight: null,
    frameWidth: null,
    assetFrameMobile: null,
    frameHeightMobile: null,
    frameWidthMobile: null,
  },
  {
    propId: 'e75726ac-8cec-4493-a608-3bf5978bc14b',
    assetId: '75476c84-3908-42c8-90ed-e536e1921c87',
    assetName: 'Main gate',
    assetType: 'NETCAM',
    assetUrl: 'rtsp://admin:Admin@123@192.168.1.13',
    assetUrlPlaylist: 'https://rtsp.me/embed/kd43dBY2/',
    assetLocation:
      '[{"label":"Pahalgam Sub-District, Jammu & Kashmir, India","countryCode":"IND","countryName":"India","stateCode":"JK","state":"Jammu & Kashmir","county":"Anantnag","postalCode":"192126","city":"Pahalgam Sub-District","lat":33.92948,"lng":75.29061}]',
    assetCreateDate: '2024-07-20T17:49:15.937',
    assetRemoveDate: null,

    computerVision: null,
    intrusion: null,
    peopleDetection: null,
    animalDetection: null,
    vehicleDetection: null,
    anpr: null,
    fire: null,
    faceRecognization: null,
    settingCreateDate: null,
    settingCreateDateBy: null,
    settingUpdateDate: null,
    settingUpdateBy: null,
    settingMode: null,

    assetFrame: null,
    frameHeight: null,
    frameWidth: null,
    assetFrameMobile: null,
    frameHeightMobile: null,
    frameWidthMobile: null,
  },
  {
    propId: 'e75726ac-8cec-4493-a608-3bf5978bc14b',
    assetId: '34562c84-3457-42c8-90ed-e536e1921c87',
    assetName: 'Main gate',
    assetType: 'NETCAM',
    assetUrl: 'rtsp://admin:Admin@123@192.168.1.13',
    assetUrlPlaylist: 'https://rtsp.me/embed/kd43dBY2/',
    assetLocation:
      '[{"label":"Kargil Bypass, Kargil 194103, India","countryCode":"IND","countryName":"India","stateCode":"LA","state":"Ladakh","county":"Kargil","postalCode":"194103","city":"Kargil","lat":34.55678,"lng":76.14333}]',
    assetCreateDate: '2024-07-20T17:49:15.937',
    assetRemoveDate: null,

    computerVision: null,
    intrusion: null,
    peopleDetection: null,
    animalDetection: null,
    vehicleDetection: null,
    anpr: null,
    fire: null,
    faceRecognization: null,
    settingCreateDate: null,
    settingCreateDateBy: null,
    settingUpdateDate: null,
    settingUpdateBy: null,
    settingMode: null,

    assetFrame: null,
    frameHeight: null,
    frameWidth: null,
    assetFrameMobile: null,
    frameHeightMobile: null,
    frameWidthMobile: null,
  },
  {
    propId: 'e75726ac-8cec-4493-a608-3bf5978bc14b',
    assetId: '34216c84-9809-42c8-90ed-e536e1921c87',
    assetName: 'Main gate',
    assetType: 'NETCAM',
    assetUrl: 'rtsp://admin:Admin@123@192.168.1.13',
    assetUrlPlaylist: 'https://rtsp.me/embed/kd43dBY2/',
    assetLocation:
      '[{"label":"Marwah, Jammu & Kashmir, India","countryCode":"IND","countryName":"India","stateCode":"JK","state":"Jammu & Kashmir","county":"Kishtwar","postalCode":"182205","city":"Marwah","lat":33.77015,"lng":75.58939}]',
    assetCreateDate: '2024-07-20T17:49:15.937',
    assetRemoveDate: null,

    computerVision: null,
    intrusion: null,
    peopleDetection: null,
    animalDetection: null,
    vehicleDetection: null,
    anpr: null,
    fire: null,
    faceRecognization: null,
    settingCreateDate: null,
    settingCreateDateBy: null,
    settingUpdateDate: null,
    settingUpdateBy: null,
    settingMode: null,

    assetFrame: null,
    frameHeight: null,
    frameWidth: null,
    assetFrameMobile: null,
    frameHeightMobile: null,
    frameWidthMobile: null,
  },
];
export const orgUsers: UserRegDetails[] = [
  {
    orgID: '766773b7-51e9-4951-a2de-6245e6233758',
    userId: '7cdf8b9f-d52c-41bc-a419-00795e871a52',
    userName: null,
    firstname: 'Sachin',
    lastname: 'Testing',
    email: '',
    phoneNumber: '+919839300801',
    gender: 'Not Added',
    userAddress: 'Lucknow, UP ',
    userAssetAccess: null,
    userRole: 'user',
    userStatus: 0,
    identityID: null,
    profilePicture: null,
    additionalPhoto: null,
    vibrationAccess: null,
    locationAccess: null,
    userVehicles: null,
    isManuallyVerified: 'false',
    isEmployee: 'false',
    employeeDepartment: null,
    employeeQR: '',
    employeeAttendance: null,
    isSelfAttendance: 'false',
    isDownloadAllowed: 'false',
    userLocation: null,
  },
  {
    orgID: '766773b7-51e9-4951-a2de-6245e6233758',
    userId: '422e37a6-c5d4-4c94-9f9f-0e68b9ab27dc',
    userName: null,
    firstname: 'Bijay Kumar',
    lastname: 'Murmu',
    email: 'bijay.murmu@cyclopssecurityservices.com',
    phoneNumber: '+917606945333',
    dateOfBirth: null,
    gender: 'male',
    userAddress: '',
    userAssetAccess: null,
    userRole: 'admin',
    userStatus: 1,
    identityID:
      'https://imagetoragelog.blob.core.windows.net/imagefilestorage/Users/C%3A%5Clocal%5CTemp%5C422e37a6-c5d4-4c94-9f9f-0e68b9ab27dcid.jpg',
    profilePicture:
      'https://imagetoragelog.blob.core.windows.net/imagefilestorage/Users/C%3A%5Clocal%5CTemp%5C422e37a6-c5d4-4c94-9f9f-0e68b9ab27dcphoto.jpg',
    additionalPhoto: null,
    vibrationAccess: '1',
    locationAccess: '1',
    userVehicles: null,
    isManuallyVerified: 'false',
    isEmployee: 'true',
    employeeDepartment: 'SDE',
    employeeQR:
      'https://imagetoragelog.blob.core.windows.net/imagefilestorage/images/C%3A%5CUsers%5CSachin%5CAppData%5CLocal%5CTemp%5C5480a3ad-98f7-438c-8a26-df65584b334b.png',
    employeeAttendance: null,
    isSelfAttendance: 'true',
    isDownloadAllowed: 'true',
    userLocation:
      '[{"label":"5-A, Bda Colony, Chandrasekharpur, Bhubaneswar 751023, India","countryCode":"IND","countryName":"India","stateCode":"OD","state":"Odisha","county":"Khordha","postalCode":"751023","city":"Bhubaneswar","lat":20.31958,"lng":85.81948},{"label":"Maa Singhabahini Brass Band, MDR, Jaydev Vihar, Jayadev Vihar, Bhubaneswar 751013, India","countryCode":"IND","countryName":"India","stateCode":"OD","state":"Odisha","county":"Khordha","postalCode":"751013","city":"Bhubaneswar","lat":20.29605,"lng":85.82452},{"label":"Aastha Cosmetic, Patharagadia, Bhubaneswar 751024, India","countryCode":"IND","countryName":"India","stateCode":"OD","state":"Odisha","county":"Khordha","postalCode":"751024","city":"Bhubaneswar","lat":20.36392,"lng":85.79741}]',
  },
  {
    orgID: '766773b7-51e9-4951-a2de-6245e6233758',
    userId: 'bece604d-c521-44d3-85fb-1402926463df',
    userName: null,
    firstname: 'Pradyuman',
    lastname: 'Rana',
    email: 'pradyuman@cyclopssecurityservices.com',
    phoneNumber: '+917838880235',
    gender: 'Not Added',
    userAddress: 'gurgaon sector 112',
    userAssetAccess: null,
    userRole: 'admin',
    userStatus: 1,
    identityID:
      'https://imagetoragelog.blob.core.windows.net/imagefilestorage/6ef7e5a7-d2da-48da-9c4c-6a74b40f59a8.jpg',
    profilePicture:
      'https://imagetoragelog.blob.core.windows.net/imagefilestorage/ed9e39dd-e711-4312-ac5f-34679c6341ec.jpg',
    additionalPhoto: null,
    vibrationAccess: null,
    locationAccess: null,
    userVehicles: null,
    isManuallyVerified: 'false',
    isEmployee: 'true',
    employeeDepartment: 'Head',
    employeeQR:
      'https://imagetoragelog.blob.core.windows.net/imagefilestorage/images/C%3A%5CUsers%5CSachin%5CAppData%5CLocal%5CTemp%5C872c0c6b-862f-4078-92de-cf296bd3ece0.png',
    employeeAttendance:
      '[{"AttendanceLogId":"T5bRHGl","LogDate":"2024-02-01T00:00:00+00:00","LogDay":"Thursday","EmployeeLogDetails":[{"LogIndex":1,"LogInDate":"2024-02-01T13:46:35.2088304+00:00","LogOutDate":"2024-02-01T13:50:19.4254785+00:00","LogDifference":0.06228240225}],"Status":1,"TotalHours":"0:03 hours"},{"AttendanceLogId":"2AC4WrG","LogDate":"2024-08-26T00:00:00+00:00","LogDay":"Monday","EmployeeLogDetails":[{"LogIndex":1,"LogInDate":"2024-08-26T05:34:24.9350086+00:00","LogOutDate":"2024-08-26T05:34:30.8716709+00:00","LogDifference":0.0016490728611111111}],"Status":1,"TotalHours":"0:00 hours"}]',
    isSelfAttendance: 'false',
    isDownloadAllowed: 'false',
    userLocation: null,
  },
  {
    orgID: '766773b7-51e9-4951-a2de-6245e6233758',
    userId: '14e0ef01-d4b5-4548-93b8-1b647541028c',
    userName: null,
    firstname: 'Sec',
    lastname: 'Dalal',
    email: 'consultant@c-dsai.com',
    phoneNumber: '+917016192158',
    gender: 'Not Added',
    userAddress: 'london',
    userAssetAccess: null,
    userRole: 'user',
    userStatus: 1,
    identityID:
      'https://imagetoragelog.blob.core.windows.net/imagefilestorage/05786728-d623-45d6-ad74-11a3eed04c9e.jpg',
    profilePicture:
      'https://imagetoragelog.blob.core.windows.net/imagefilestorage/882e4812-dffe-40e7-8ffe-4a5b7ede5b0d.jpg',
    additionalPhoto: null,
    vibrationAccess: null,
    locationAccess: null,
    userVehicles: null,
    isManuallyVerified: 'true',
    isEmployee: 'true',
    employeeDepartment: 'security',
    employeeQR:
      'https://imagetoragelog.blob.core.windows.net/imagefilestorage/images/C%3A%5CUsers%5CSachin%5CAppData%5CLocal%5CTemp%5C96db6257-3d39-4a9e-9486-2c20a4c1294f.png',
    employeeAttendance: null,
    isSelfAttendance: 'false',
    isDownloadAllowed: 'false',
    userLocation: null,
  },
  {
    orgID: '766773b7-51e9-4951-a2de-6245e6233758',
    userId: '5a9f6188-e34c-4f65-b0ac-227378b95660',
    userName: null,
    firstname: 'Prathana',
    lastname: 'Jena',
    email: 'prathanajena74@gmail.com',
    phoneNumber: '+918447917213',
    gender: 'female',
    userAddress: 'uttam nagar ',
    userAssetAccess: '[]',
    userRole: 'admin',
    userStatus: 1,
    identityID:
      'https://imagetoragelog.blob.core.windows.net/imagefilestorage/c7d6b480-b91d-4ab6-b5e9-8f44c2d0e688.jpg',
    profilePicture:
      'https://imagetoragelog.blob.core.windows.net/imagefilestorage/02305a5c-d0a9-4ab4-befc-b2c3cd71f68dphoto.jpg',
    additionalPhoto:
      'https://imagetoragelog.blob.core.windows.net/imagefilestorage/c292ea0b-44e3-4aa3-9979-d72b2f18941d.jpg',
    vibrationAccess: null,
    locationAccess: '1',
    userVehicles: null,
    isManuallyVerified: 'false',
    isEmployee: 'true',
    employeeDepartment: 'Business Development Executive',
    employeeQR:
      'https://imagetoragelog.blob.core.windows.net/imagefilestorage/images/C%3A%5CUsers%5CSachin%5CAppData%5CLocal%5CTemp%5C1868646f-96ba-4b01-9f02-2025e7259357.png',
    employeeAttendance: null,

    isSelfAttendance: 'true',
    isDownloadAllowed: 'true',
    userLocation:
      '[{"label":"Mahavir Enclave, H-1/43A, Part 1-Bangali Colony-Block H1, Mahavir Enclave, Delhi 110045, India","countryCode":"IND","countryName":"India","stateCode":"DL","state":"Delhi","county":"South West","postalCode":"110045","city":"Delhi","lat":28.59712,"lng":77.07871},{"label":"B2/1, Dashrathpuri-Block B2, Dabri, Delhi 110045, India","countryCode":"IND","countryName":"India","stateCode":"DL","state":"Delhi","county":"South West","postalCode":"110045","city":"Delhi","lat":28.60402,"lng":77.08371},{"label":"H-3/45, Part 1-Bangali Colony-Block H1, Mahavir Enclave, Delhi 110045, India","countryCode":"IND","countryName":"India","stateCode":"DL","state":"Delhi","county":"South West","postalCode":"110045","city":"Delhi","lat":28.59711,"lng":77.07906},{"label":"H-3/47, Part 1-Bangali Colony-Block H3, Mahavir Enclave, Delhi 110045, India","countryCode":"IND","countryName":"India","stateCode":"DL","state":"Delhi","county":"South West","postalCode":"110045","city":"Delhi","lat":28.59712,"lng":77.07881},{"label":"Jansewa Dental Services, Dwarka Puri-Block B, Vijay Enclave, Delhi 110045, India","countryCode":"IND","countryName":"India","stateCode":"DL","state":"Delhi","county":"South West","postalCode":"110045","city":"Delhi","lat":28.60647,"lng":77.08017}]',
  },
  {
    orgID: '766773b7-51e9-4951-a2de-6245e6233758',
    userId: '6909057e-a81e-4194-be42-2a1c9e547132',
    userName: null,
    firstname: 'Sapna ',
    lastname: 'Kumari',
    email: 'sapna.kumari@cyclopssecurityservices.com',
    phoneNumber: '+919315660299',
    gender: 'Not Added',
    userAddress: 'uttam nagar',
    userAssetAccess: '[]',
    userRole: 'admin',
    userStatus: 1,
    identityID:
      'https://imagetoragelog.blob.core.windows.net/imagefilestorage/5903850b-5701-4070-9166-7975e3a621a4.jpg',
    profilePicture:
      'https://imagetoragelog.blob.core.windows.net/imagefilestorage/Users/C%3A%5Clocal%5CTemp%5C6909057e-a81e-4194-be42-2a1c9e547132AdditionalPhoto.jpg',
    additionalPhoto:
      'https://imagetoragelog.blob.core.windows.net/imagefilestorage/7846b418-5fce-4295-95bd-48d1989f4d20photo.jpg',
    vibrationAccess: null,
    locationAccess: '1',
    userVehicles: null,
    isManuallyVerified: 'false',
    isEmployee: 'true',
    employeeDepartment: 'SDE',
    employeeQR:
      'https://imagetoragelog.blob.core.windows.net/imagefilestorage/images/C%3A%5CUsers%5CSachin%5CAppData%5CLocal%5CTemp%5C591bb00c-e87c-4f6f-997a-0723e3c0e6b3.png',
    employeeAttendance: null,
    isSelfAttendance: 'true',
    isDownloadAllowed: 'false',
    userLocation:
      '[{"label":"H-3/45, Part 1-Bangali Colony-Block H1, Mahavir Enclave, Delhi 110045, India","countryCode":"IND","countryName":"India","stateCode":"DL","state":"Delhi","county":"South West","postalCode":"110045","city":"Delhi","lat":28.59711,"lng":77.07906}]',
  },
];

const anprEvidencesObj: any[] = [
  {
    url: 'https://imagetoragelog.blob.core.windows.net/imagefilestorage/C%3A%5CUsers%5Chp%5CAppData%5CLocal%5CTemp%5C8cb6483e-edc6-47d8-8e0f-10c1d7207e1e.jpg',
    number: 'DL12CM6052',
  },
  {
    url: 'https://imagetoragelog.blob.core.windows.net/imagefilestorage/C%3A%5CUsers%5Chp%5CAppData%5CLocal%5CTemp%5C58300adf-366d-4b49-b1f3-5c9fa8537a5e.jpg',
    number: 'DL8CBE7636',
  },
  {
    url: 'https://imagetoragelog.blob.core.windows.net/imagefilestorage/C%3A%5CUsers%5CLENOVO%5CAppData%5CLocal%5CTemp%5C70bd43af-0682-4589-93f5-d350df178a65.jpg',
    number: 'DL10CK8461',
  },
  {
    url: 'https://imagetoragelog.blob.core.windows.net/imagefilestorage/C%3A%5CUsers%5CLENOVO%5CAppData%5CLocal%5CTemp%5Cf0ba4963-e62d-4f05-bbab-d9930c3bb3fc.jpg',
    number: 'UP160Z1328',
  },
  {
    url: 'https://imagetoragelog.blob.core.windows.net/imagefilestorage/C%3A%5CUsers%5CLENOVO%5CAppData%5CLocal%5CTemp%5C491e730c-f770-49dc-bb84-d80fdc1d0853.jpg',
    number: 'DL4CAZ0870',
  },
];
// const faceEvidencesObj: any[] = [
//   {
//     url: 'https://imagetoragelog.blob.core.windows.net/imagefilestorage/Intrusion/C%3A%5CUsers%5Chp%5CAppData%5CLocal%5CTemp%5C09e3bc90-cf3a-4d92-b228-53dba4985999.png',
//     name: 'MANOJ KUMAR',
//   },
//   {
//     url: 'https://imagetoragelog.blob.core.windows.net/imagefilestorage/Intrusion/C%3A%5CUsers%5Chp%5CAppData%5CLocal%5CTemp%5C6aece0a6-002e-4623-8d42-679a4d0f979b.png',
//     name: 'ANURAG SINGH',
//   },
//   {
//     url: 'https://imagetoragelog.blob.core.windows.net/imagefilestorage/Intrusion/C%3A%5CUsers%5Chp%5CAppData%5CLocal%5CTemp%5Cfeb75e0d-270c-40d5-9e8a-689926cd6c1e.png',
//     name: 'GOURAV NIMAVAT',
//   },
//   {
//     url: 'https://imagetoragelog.blob.core.windows.net/imagefilestorage/Facerecognition/C%3A%5CUsers%5Chp%5CAppData%5CLocal%5CTemp%5C9/24/2024%202%3A52%3A28%20PM87c8b7b0-1be2-4f75-8734-4abb3cf833d1.png',
//     name: 'PRATHANA JENA',
//   },
//   {
//     url: 'https://imagetoragelog.blob.core.windows.net/imagefilestorage/Intrusion/C%3A%5CUsers%5Chp%5CAppData%5CLocal%5CTemp%5C254514ba-5379-44d4-bc68-9b2a2ec795a1.png',
//     name: 'RAJESH KUMAR',
//   },
// ];
const faceEvidencesObj: any[] = [
  {
    url: 'https://imagetoragelog.blob.core.windows.net/imagefilestorage/Intrusion/C%3A%5CUsers%5Chp%5CAppData%5CLocal%5CTemp%5C09e3bc90-cf3a-4d92-b228-53dba4985999.png',
    name: 'MANOJ KUMAR',
  },
  {
    url: 'https://imagetoragelog.blob.core.windows.net/imagefilestorage/Intrusion/C%3A%5CUsers%5Chp%5CAppData%5CLocal%5CTemp%5C254514ba-5379-44d4-bc68-9b2a2ec795a1.png',
    name: 'RAJESH KUMAR',
  },
  {
    url: 'https://imagetoragelog.blob.core.windows.net/imagefilestorage/Intrusion/C%3A%5CUsers%5Chp%5CAppData%5CLocal%5CTemp%5C6aece0a6-002e-4623-8d42-679a4d0f979b.png',
    name: 'ANURAG SINGH',
  },
  {
    url: 'https://imagetoragelog.blob.core.windows.net/imagefilestorage/Facerecognition/C%3A%5CUsers%5Chp%5CAppData%5CLocal%5CTemp%5C9/24/2024%202%3A52%3A28%20PM87c8b7b0-1be2-4f75-8734-4abb3cf833d1.png',
    name: 'PRATHANA JENA',
  },
  {
    url: 'https://imagetoragelog.blob.core.windows.net/imagefilestorage/Intrusion/C%3A%5CUsers%5Chp%5CAppData%5CLocal%5CTemp%5Cfeb75e0d-270c-40d5-9e8a-689926cd6c1e.png',
    name: 'GOURAV NIMAVAT',
  },
];

// 10
const intrusionEvidences: string[] = [
  'https://imagetoragelog.blob.core.windows.net/imagefilestorage/C%3A%5CUsers%5Chp%5CAppData%5CLocal%5CTemp%5Cba1b2fee-1e4b-4d03-b22c-003bfe12f6a1.jpg',
  'https://imagetoragelog.blob.core.windows.net/imagefilestorage/C%3A%5CUsers%5Chp%5CAppData%5CLocal%5CTemp%5C56ba681d-d1c1-4869-820c-0086a48a224a.jpg',
  'https://imagetoragelog.blob.core.windows.net/imagefilestorage/Intrusion/C%3A%5CUsers%5Chp%5CAppData%5CLocal%5CTemp%5C0b86d589-b0b8-4ef1-b608-009669b250f6.png',
  'https://imagetoragelog.blob.core.windows.net/imagefilestorage/C%3A%5CUsers%5Chp%5CAppData%5CLocal%5CTemp%5Cfd046440-df50-4bd2-a3f2-01b3fb255f23.jpg',
  'https://imagetoragelog.blob.core.windows.net/imagefilestorage/Intrusion/C%3A%5CUsers%5Chp%5CAppData%5CLocal%5CTemp%5C5a977d62-e7f3-4bf4-9ba1-02155430fb76.png',
  'https://imagetoragelog.blob.core.windows.net/imagefilestorage/Intrusion/C%3A%5CUsers%5Chp%5CAppData%5CLocal%5CTemp%5C13cc6110-c157-4fe1-aaa3-0239434b0581.png',
  'https://imagetoragelog.blob.core.windows.net/imagefilestorage/C%3A%5CUsers%5Chp%5CAppData%5CLocal%5CTemp%5C510752ac-adc3-4056-ba47-023bfabcf8b7.jpg',
  'https://imagetoragelog.blob.core.windows.net/imagefilestorage/Intrusion/C%3A%5CUsers%5CAumye%20gateway%5CAppData%5CLocal%5CTemp%5C2528d1c0-c348-48b0-b341-027b44742032.png',
  'https://imagetoragelog.blob.core.windows.net/imagefilestorage/C%3A%5CUsers%5Chp%5CAppData%5CLocal%5CTemp%5C1874784f-e57e-4e98-8d47-02b75a01b3b7.png',
  'https://imagetoragelog.blob.core.windows.net/imagefilestorage/C%3A%5CUsers%5Chp%5CAppData%5CLocal%5CTemp%5C2999d233-3e53-4bd2-8e19-02ce4b5da57a.jpg',
];
//5 - 10
const anprEvidences: any[] = [
  'https://imagetoragelog.blob.core.windows.net/imagefilestorage/C%3A%5CUsers%5Chp%5CAppData%5CLocal%5CTemp%5C8cb6483e-edc6-47d8-8e0f-10c1d7207e1e.jpg',
  'https://imagetoragelog.blob.core.windows.net/imagefilestorage/C%3A%5CUsers%5Chp%5CAppData%5CLocal%5CTemp%5C58300adf-366d-4b49-b1f3-5c9fa8537a5e.jpg',
  'https://imagetoragelog.blob.core.windows.net/imagefilestorage/C%3A%5CUsers%5CLENOVO%5CAppData%5CLocal%5CTemp%5C70bd43af-0682-4589-93f5-d350df178a65.jpg',
  'https://imagetoragelog.blob.core.windows.net/imagefilestorage/C%3A%5CUsers%5CLENOVO%5CAppData%5CLocal%5CTemp%5Cf0ba4963-e62d-4f05-bbab-d9930c3bb3fc.jpg',
  'https://imagetoragelog.blob.core.windows.net/imagefilestorage/C%3A%5CUsers%5CLENOVO%5CAppData%5CLocal%5CTemp%5C491e730c-f770-49dc-bb84-d80fdc1d0853.jpg',
];
const faceEvidences: any[] = [
  'https://imagetoragelog.blob.core.windows.net/imagefilestorage/Intrusion/C%3A%5CUsers%5Chp%5CAppData%5CLocal%5CTemp%5C09e3bc90-cf3a-4d92-b228-53dba4985999.png',
  'https://imagetoragelog.blob.core.windows.net/imagefilestorage/Intrusion/C%3A%5CUsers%5Chp%5CAppData%5CLocal%5CTemp%5C6aece0a6-002e-4623-8d42-679a4d0f979b.png',
  'https://imagetoragelog.blob.core.windows.net/imagefilestorage/Intrusion/C%3A%5CUsers%5Chp%5CAppData%5CLocal%5CTemp%5Cfeb75e0d-270c-40d5-9e8a-689926cd6c1e.png',
  'https://imagetoragelog.blob.core.windows.net/imagefilestorage/Facerecognition/C%3A%5CUsers%5Chp%5CAppData%5CLocal%5CTemp%5C9/24/2024%202%3A52%3A28%20PM87c8b7b0-1be2-4f75-8734-4abb3cf833d1.png',
  'https://imagetoragelog.blob.core.windows.net/imagefilestorage/Intrusion/C%3A%5CUsers%5Chp%5CAppData%5CLocal%5CTemp%5C254514ba-5379-44d4-bc68-9b2a2ec795a1.png',
];
const fireEvidences: string[] = [
  'https://imagetoragelog.blob.core.windows.net/imagefilestorage/C%3A%5CUsers%5Chp%5CAppData%5CLocal%5CTemp%5Cafc89f10-3855-4ce8-bfab-39f05a3919c0.jpg',
  'https://imagetoragelog.blob.core.windows.net/imagefilestorage/C%3A%5CUsers%5Chp%5CAppData%5CLocal%5CTemp%5Cbe0ae27f-6d25-4674-9aed-47c1b8b6e1db.jpg',
  'https://imagetoragelog.blob.core.windows.net/imagefilestorage/C%3A%5CUsers%5Chp%5CAppData%5CLocal%5CTemp%5Ce94e7d36-2091-4a44-9b8c-2498724ec7b5.jpg',
  'https://imagetoragelog.blob.core.windows.net/imagefilestorage/C%3A%5CUsers%5Chp%5CAppData%5CLocal%5CTemp%5C0130db58-fe84-47d3-b92d-257462ea4209.jpg',
  'https://imagetoragelog.blob.core.windows.net/imagefilestorage/C%3A%5CUsers%5Chp%5CAppData%5CLocal%5CTemp%5Cf2d91324-5867-4f2a-a741-277f1826d77f.jpg',
  'https://imagetoragelog.blob.core.windows.net/imagefilestorage/C%3A%5CUsers%5Chp%5CAppData%5CLocal%5CTemp%5Cf2f8dd03-ccc5-4ae9-9179-28f995724034.jpg',
  'https://imagetoragelog.blob.core.windows.net/imagefilestorage/C%3A%5CUsers%5Chp%5CAppData%5CLocal%5CTemp%5Cf211d507-ab1c-4f13-abb2-29e56696c2e2.jpg',
  'https://imagetoragelog.blob.core.windows.net/imagefilestorage/C%3A%5CUsers%5Chp%5CAppData%5CLocal%5CTemp%5Cb174a990-f36f-41ba-bc26-03400855bdf4.jpg',
];
const getDatesArray = (days: number): Date[] => {
  const datesArray: Date[] = [];
  for (let i = 0; i < days; i++) {
    const date = new Date();
    date.setDate(date.getDate() - i);
    datesArray.push(new Date(date)); // Pushing a copy of the date
  }
  return datesArray;
};

// Example usage
// const dates = getDatesArray(4); // Array of dates from current date to 5 days ago
export function CreateRiskQuestions(val: any[]) {
  let riskQuestions: IRiskQuestions[] = [];
  val.forEach((x) => {
    riskQuestions.push({
      riskQuestion: x.title,
      riskCriticality: x.criticality,
      riskFrequency: x.frequency,
      riskTotal: x.total,
    });
  });
  return riskQuestions;
}

export function SaveRiskQuestionsToStore(val: IRiskQuestions[]) {
  console.log(val);
  let riskQuestions: IRiskQuestions[] = [];
}
export function GetRiskData() {
  let data: IAnalyticsData;
  // data.riskQuestions = CreateRiskQuestions()
}
export function CreateIntrusion(): IIncidents {
  let incident: IIncidents;
  let incidentId = uuidv4();
  let dates = getDatesArray(4);
  let asset: IAssets = assets[generateRandomNumber(assets.length - 1)];
  const orgId = localStorage.getItem('OrganizationId');
  incident = {
    orgId: orgId,
    incidentId: incidentId,
    incidentName: 'Intrusion',
    incidentType: 'Automatic',
    incidentLocation: asset.assetLocation,
    incidentDescription: 'Intrusion',
    sourceAsset: asset.assetName,
    sourceAssetId: asset.assetId,
    incidentStatus: 0,
    incidentCriticality: 'High',
    assignedTo: null,
    assignedToUserId: null,
    incidentReporter: null,
    eventEvidence:
      intrusionEvidences[generateRandomNumber(intrusionEvidences.length - 1)],
    eventCreatedBy: null,
    eventCreateDate:
      dates[generateRandomNumber(dates.length - 1)].toISOString(),
    eventClosedDate: null,
    eventCreatedByUserID: null,
    isManualEvent: '1',
    eventSnoozeDeadline: null,
    eventOwnerName: null,
    eventOwnerEmail: null,
    eventOwnerPhone: null,
    isFaceMatch: 0,
    faceDetectedName: null,
    faceDetectDateTime: null,
    faceTimeline: null,
    isANPR: 0,
    anprDetectedNumber: null,
    anprDetectDateTime: null,
    anprTimeline: null,
    incidentGraph: createIncidentGraph(0),
    incidentComments: createComment(
      [],
      'An Intrusion has been detected and being automatically reported',
      incidentId
    ),
    multipleEvidence: null,
  };
  return incident;
}
export function CreateFire(): IIncidents {
  let incident: IIncidents;
  let incidentId = uuidv4();
  let dates = getDatesArray(4);
  let asset: IAssets = assets[generateRandomNumber(assets.length - 1)];
  const orgId = localStorage.getItem('OrganizationId');
  incident = {
    orgId: orgId,
    incidentId: incidentId,
    incidentName: 'Fire',
    incidentType: 'Automatic',
    incidentLocation: asset.assetLocation,
    incidentDescription: 'Fire',
    sourceAsset: asset.assetName,
    sourceAssetId: asset.assetId,
    incidentStatus: 0,
    incidentCriticality: 'High',
    assignedTo: null,
    assignedToUserId: null,
    incidentReporter: null,
    eventEvidence:
      fireEvidences[generateRandomNumber(fireEvidences.length - 1)],
    eventCreatedBy: null,
    eventCreateDate:
      dates[generateRandomNumber(dates.length - 1)].toISOString(),
    eventClosedDate: null,
    eventCreatedByUserID: null,
    isManualEvent: '1',
    eventSnoozeDeadline: null,
    eventOwnerName: null,
    eventOwnerEmail: null,
    eventOwnerPhone: null,
    isFaceMatch: 0,
    faceDetectedName: null,
    faceDetectDateTime: null,
    faceTimeline: null,
    isANPR: 0,
    anprDetectedNumber: null,
    anprDetectDateTime: null,
    anprTimeline: null,
    incidentGraph: createIncidentGraph(0),
    incidentComments: createComment(
      [],
      'A Fire has been detected and being automatically reported',
      incidentId
    ),
    multipleEvidence: null,
  };
  return incident;
}
export function GetTimeline(val: string): Date[] {
  let n = generateRandomNumber(10);
  if (n == 0) n = 1;
  const dates: Date[] = [];
  let currentDate = new Date(val);
  for (let i = 1; i <= n; i++) {
    dates.push(new Date(currentDate));
    const randomMinutes = 10 + Math.floor(Math.random() * 6);
    currentDate = new Date(currentDate.getTime() + randomMinutes * 60000);
  }
  return dates;
}
function formatDate(date: Date): string {
  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: true,
  };

  return date.toLocaleString('en-US', options);
}
export function CreateANPR(): IIncidents {
  let incident: IIncidents;
  let incidentId = uuidv4();
  let dates = getDatesArray(4);
  let asset: IAssets = assets[generateRandomNumber(assets.length - 1)];
  let numberDetails =
    anprEvidencesObj[generateRandomNumber(anprEvidencesObj.length - 1)];
  let date = dates[generateRandomNumber(dates.length - 1)].toISOString();
  let timeline = GetTimeline(date);
  const orgId = localStorage.getItem('OrganizationId');
  incident = {
    orgId: orgId,
    incidentId: incidentId,
    incidentName: 'ANPR Detected',
    incidentType: 'Automatic',
    incidentLocation: asset.assetLocation,
    incidentDescription: numberDetails.number,
    sourceAsset: asset.assetName,
    sourceAssetId: asset.assetId,
    incidentStatus: 0,
    incidentCriticality: 'High',
    assignedTo: null,
    assignedToUserId: null,
    incidentReporter: null,
    eventEvidence: numberDetails.url,
    eventCreatedBy: null,
    eventCreateDate: date,
    eventClosedDate: null,
    eventCreatedByUserID: null,
    isManualEvent: '1',
    eventSnoozeDeadline: null,
    eventOwnerName: null,
    eventOwnerEmail: null,
    eventOwnerPhone: null,
    isFaceMatch: 0,
    faceDetectedName: null,
    faceDetectDateTime: null,
    faceTimeline: null,
    isANPR: 1,
    anprDetectedNumber: null,
    anprDetectDateTime: JSON.stringify(timeline),
    anprTimeline: timeline,
    incidentGraph: createIncidentGraph(0),
    incidentComments: createComment(
      [],
      'A Number plated was detected and being automatically reported: ' +
        numberDetails.number +
        ' on ' +
        new Date(),
      incidentId
    ),
    multipleEvidence: null,
  };
  return incident;
}
export function CreateFace(): IIncidents {
  let incident: IIncidents;
  let incidentId = uuidv4();
  let dates = getDatesArray(4);
  let asset: IAssets = assets[generateRandomNumber(assets.length - 1)];
  let faceDetails =
    faceEvidencesObj[generateRandomNumber(faceEvidencesObj.length - 1)];
  let user: UserRegDetails =
    orgUsers[generateRandomNumber(orgUsers.length - 1)];
  let date = dates[generateRandomNumber(dates.length - 1)].toISOString();
  let timeline = GetTimeline(date);
  const orgId = localStorage.getItem('OrganizationId');
  incident = {
    orgId: orgId,
    incidentId: incidentId,
    incidentName: 'Face Detected',
    incidentType: 'Automatic',
    incidentLocation: asset.assetLocation,
    incidentDescription: faceDetails.name,
    sourceAsset: asset.assetName,
    sourceAssetId: asset.assetId,
    incidentStatus: 0,
    incidentCriticality: 'High',
    assignedTo: null,
    assignedToUserId: null,
    incidentReporter: null,
    eventEvidence: faceDetails.url,
    eventCreatedBy: null,
    eventCreateDate: date,
    eventClosedDate: null,
    eventCreatedByUserID: null,
    isManualEvent: '1',
    eventSnoozeDeadline: null,
    eventOwnerName: null,
    eventOwnerEmail: null,
    eventOwnerPhone: null,
    isFaceMatch: 1,
    faceDetectedName: null,
    faceDetectDateTime: JSON.stringify(timeline),
    faceTimeline: timeline,
    isANPR: 0,
    anprDetectedNumber: null,
    anprDetectDateTime: null,
    anprTimeline: null,
    incidentGraph: createIncidentGraph(0),
    incidentComments: createComment(
      [],
      'A face has been detected and being automatically reported: ' +
        faceDetails.name +
        ' on ' +
        new Date(),
      incidentId
    ),
    multipleEvidence: null,
  };
  return incident;
}
export function CreateSOS(location: ILocation): IIncidents {
  let incident: IIncidents;
  let incidentId = uuidv4();
  let creator: UserRegDetails =
    orgUsers[generateRandomNumber(orgUsers.length - 1)];
  const orgId = localStorage.getItem('OrganizationId');
  incident = {
    orgId: orgId,
    incidentId: incidentId,
    incidentName: 'Advanced SOS',
    incidentType: 'Manual',
    incidentLocation: JSON.stringify(location),
    incidentDescription: 'A user has requested emergency assistance',
    sourceAsset: null,
    sourceAssetId: null,
    incidentStatus: 0,
    incidentCriticality: 'High',
    assignedTo: null,
    assignedToUserId: null,
    incidentReporter: null,
    eventEvidence: null,
    eventCreatedBy: creator.firstname + ' ' + creator.lastname,
    eventCreateDate: new Date().toISOString(),
    eventClosedDate: null,
    eventCreatedByUserID: creator.userId,
    isManualEvent: '1',
    eventSnoozeDeadline: null,
    eventOwnerName: null,
    eventOwnerEmail: null,
    eventOwnerPhone: null,
    isFaceMatch: 0,
    faceDetectedName: null,
    faceDetectDateTime: null,
    faceTimeline: null,
    isANPR: 0,
    anprDetectedNumber: null,
    anprDetectDateTime: null,
    anprTimeline: null,
    incidentGraph: createIncidentGraph(0),
    incidentComments: createComment(
      [],
      creator.firstname +
        ' ' +
        creator.lastname +
        ' has requested for the location SOS ',
      incidentId
    ),
    multipleEvidence: null,
  };
  return incident;
}
export function CreateManualIncident(
  incidentName: string,
  incidentDescription: string,
  incidentCriticality: string
): IIncidents {
  let incident: IIncidents;
  let incidentId = uuidv4();
  let dates = getDatesArray(4);
  let creator: UserRegDetails =
    orgUsers[generateRandomNumber(orgUsers.length - 1)];
  let assigne: UserRegDetails =
    orgUsers[generateRandomNumber(orgUsers.length - 1)];
  const orgId = localStorage.getItem('OrganizationId');
  incident = {
    orgId: orgId,
    incidentId: incidentId,
    incidentName: incidentName,
    incidentType: 'Manual',
    incidentLocation: JSON.stringify([
      locations[generateRandomNumber(locations.length - 1)],
    ]),
    incidentDescription: incidentDescription,
    sourceAsset: null,
    sourceAssetId: null,
    incidentStatus: 0,
    incidentCriticality: incidentCriticality,
    assignedTo: assigne.firstname + ' ' + assigne.lastname,
    assignedToUserId: assigne.userId,
    incidentReporter: null,
    eventEvidence: null,
    eventCreatedBy: creator.firstname + ' ' + creator.lastname,
    eventCreateDate:
      dates[generateRandomNumber(dates.length - 1)].toISOString(),
    eventClosedDate: null,
    eventCreatedByUserID: creator.userId,
    isManualEvent: '1',
    eventSnoozeDeadline: null,
    eventOwnerName: null,
    eventOwnerEmail: null,
    eventOwnerPhone: null,
    isFaceMatch: 0,
    faceDetectedName: null,
    faceDetectDateTime: null,
    faceTimeline: null,
    isANPR: 0,
    anprDetectedNumber: null,
    anprDetectDateTime: null,
    anprTimeline: null,
    incidentGraph: createIncidentGraph(0),
    incidentComments: createComment(
      [],
      creator.firstname +
        ' ' +
        creator.lastname +
        ' has created a manual incident on ' +
        new Date(),
      incidentId
    ),
    multipleEvidence: null,
  };
  return incident;
}
export function CreateIntrusionSos(val: IIncidents): IRequest {
  const orgId = localStorage.getItem('OrganizationId');
  let asset = assets.find((x) => x.assetId == val.sourceAssetId);
  let incidentSos: IRequest = {
    orgID: orgId,
    requestId: val.incidentId,
    requestUserId: val.sourceAssetId,
    requestUserName: val.incidentName + ' from ' + val.sourceAsset,
    requestLatitude: JSON.parse(asset.assetLocation)[0].lat,
    requestLongitude: JSON.parse(asset.assetLocation)[0].lng,
    latitude: JSON.parse(asset.assetLocation)[0].lat,
    longitude: JSON.parse(asset.assetLocation)[0].lng,
    isIncident: true,
    requestedLocation: JSON.parse(asset.assetLocation)[0].label,
    requestCreateDateTime: new Date(),
    respondIds: null,
    respondData: [],
  };
  return incidentSos;
}
export function CreateAdvancedSos(
  val: IIncidents,
  isManual: boolean
): IRequest {
  const orgId = localStorage.getItem('OrganizationId');
  let incidentSos: IRequest = {
    orgID: orgId,
    requestId: val.incidentId,
    requestUserId: val.eventCreatedByUserID,
    requestUserName: val.eventCreatedBy,
    requestLatitude: JSON.parse(val.incidentLocation).lat,
    requestLongitude: JSON.parse(val.incidentLocation).lng,
    latitude: JSON.parse(val.incidentLocation).lat,
    longitude: JSON.parse(val.incidentLocation).lng,
    isIncident: false,
    requestedLocation: JSON.parse(val.incidentLocation).label,
    requestCreateDateTime: new Date(),
    respondIds: null,
    respondData: [],
  };
  if (isManual) {
    return incidentSos;
  } else {
    let respond: IRespond = getManualResponderToRequest(incidentSos);
    let respondIdsList: string[] = [];
    respondIdsList.push(respond.respondId);
    incidentSos.respondIds = JSON.stringify(respondIdsList);
    incidentSos.respondData.push(respond);
    return incidentSos;
  }
}
export function getResponderLocationToCloud() {
  setTimeout(() => {
    // this.aumyeEmergencyLocationService.updateLocation();
  }, 1000);
}
export function getManualResponderToRequest(val: IRequest): IRespond {
  let user: UserRegDetails[] = orgUsers.filter(
    (x) =>
      x.userId != val.requestUserId &&
      x.userId != 'bfaae4f7-b2e3-42f4-8e92-9dcdd44c27e1'
  );
  let respondUser: UserRegDetails = user[generateRandomNumber(user.length - 1)];
  let location: ILocation =
    locations[generateRandomNumber(locations.length - 1)];
  let respond: IRespond = {
    respondId: uuidv4(),
    respondUserId: respondUser.userId,
    respondUserName: respondUser.firstname + ' ' + respondUser.lastname,
    respondLatitude: location.lat.toString(),
    respondLongitude: location.lng.toString(),
    respondedLocation: location.label,
    respondDateTime: new Date(),
    latitude: location.lat.toString(),
    longitude: location.lng.toString(),
  };
  return respond;
}

export function generateRandomNumber(n: number): number {
  return Math.floor(Math.random() * (n + 1));
}
export function createIncidentGraph(status: number): IncidentTimelineGrpah[] {
  let singleIncident: IncidentTimelineGrpah;
  let incidentGraph: IncidentTimelineGrpah[] = [];
  let newIsoDate = new Date().toISOString();
  singleIncident = {
    eventDate: new Date(newIsoDate),
    eventTime: formatTimeToDecimal(newIsoDate),
    status: status,
  };
  incidentGraph.push(singleIncident);
  return incidentGraph;
}
export function createComment(
  comment: IPostComments[],
  addComment: string,
  postid: string
): IPostComments[] {
  let newComment: IPostComments = {
    postId: postid,
    commentId: uuidv4(),
    commentText: addComment,
    commentUsername: 'null',
    commentUserProfile: 'null',
    commentUserId: 'null',
    isIncident: 'true',
    isVisitor: 'false',
    isAuto: 'true',
    incidentEvidence: null,
    commentAddDate: new Date(),
  };

  // Return a new array, instead of modifying the original
  return [newComment, ...comment];
}
export function createIncidentStatus(
  comment: IPostComments[],
  addComment: string,
  postid: string
): IPostComments[] {
  let newComment: IPostComments = {
    postId: postid,
    commentId: uuidv4(),
    commentText: addComment,
    commentUsername: 'null',
    commentUserProfile: 'null',
    commentUserId: 'null',
    isIncident: 'true',
    isVisitor: 'false',
    isAuto: 'true',
    incidentEvidence: null,
    commentAddDate: new Date(),
  };

  // Return a new array, instead of modifying the original
  return [newComment, ...comment];
}

// export function createComment(
//   comment: IPostComments[],
//   addComment: string,
//   postid: string
// ): IPostComments[] {
//   let newComment: IPostComments;
//   newComment = {
//     postId: postid,
//     commentId: uuidv4(),
//     commentText: addComment,
//     commentUsername: 'null',
//     commentUserProfile: 'null',
//     commentUserId: 'null',
//     isIncident: 'true',
//     isVisitor: 'false',
//     isAuto: 'true',
//     incidentEvidence: null,
//     commentAddDate: new Date(),
//   };
//   comment.push(newComment);
//   return comment;
// }
export function formatTimeToDecimal(dateString: string): number {
  const date = new Date(dateString);
  const hours = date.getHours();
  const minutes = date.getMinutes();

  // Convert minutes to decimal form
  const formattedTime = hours + minutes / 60;

  // Return the time formatted as a floating-point number with 2 decimal places
  return parseFloat(formattedTime.toFixed(2));
}
export function getbreakdownGraphData(
  incidents: IIncidents[]
): IncidentBreakdownGraph[] {
  let incidentBreakdownGraph: IncidentBreakdownGraph[] = [];
  const eventDates = [
    ...new Set(
      incidents.map((x) => new Date(x.eventCreateDate).toDateString())
    ),
  ].sort((a, b) => new Date(b).getTime() - new Date(a).getTime());

  eventDates.forEach((eventDate) => {
    const breakdown: IncidentBreakdownGraph = {
      eventDate: new Date(eventDate),
      anprCount: incidents.filter(
        (x) =>
          new Date(x.eventCreateDate).toDateString() === eventDate && x.isANPR
      ).length,
      faceMatchCount: incidents.filter(
        (x) =>
          new Date(x.eventCreateDate).toDateString() === eventDate &&
          x.isFaceMatch
      ).length,
      intrusionCount: incidents.filter(
        (x) =>
          new Date(x.eventCreateDate).toDateString() === eventDate &&
          x.incidentName === 'Intrusion'
      ).length,
      fireCount: incidents.filter(
        (x) =>
          new Date(x.eventCreateDate).toDateString() === eventDate &&
          x.incidentName === 'Fire'
      ).length,
      manualCount: incidents.filter(
        (x) =>
          new Date(x.eventCreateDate).toDateString() === eventDate &&
          x.incidentType == 'Manual'
      ).length,
      securityCallbacksCount: incidents.filter(
        (x) =>
          new Date(x.eventCreateDate).toDateString() === eventDate &&
          x.incidentName == 'Security Callback'
      ).length,
      serviceRequestCount: incidents.filter(
        (x) =>
          new Date(x.eventCreateDate).toDateString() === eventDate &&
          x.incidentName == 'Service Request'
      ).length,
      soSAlertsCount: incidents.filter(
        (x) =>
          new Date(x.eventCreateDate).toDateString() === eventDate &&
          x.incidentName == 'Advanced SOS'
      ).length,
      systemFailureCount: incidents.filter(
        (x) =>
          new Date(x.eventCreateDate).toDateString() === eventDate &&
          x.incidentName == 'APIFailure'
      ).length,
      deviceFailureCount: incidents.filter(
        (x) =>
          new Date(x.eventCreateDate).toDateString() === eventDate &&
          x.incidentName == 'DeviceFailure'
      ).length,
      claimsCount: incidents.filter(
        (x) =>
          new Date(x.eventCreateDate).toDateString() === eventDate &&
          x.incidentName == 'Claim'
      ).length,
    };

    // Add the breakdown to the result array
    incidentBreakdownGraph.push(breakdown);
  });
  return incidentBreakdownGraph;
}
export function getPieGraphData(incidents: IIncidents[]): IncidentPieGraph {
  let incidentBreakdownGraph: IncidentPieGraph;
  const eventDates = [
    ...new Set(
      incidents.map((x) => new Date(x.eventCreateDate).toDateString())
    ),
  ].sort((a, b) => new Date(b).getTime() - new Date(a).getTime());

  eventDates.forEach((eventDate) => {
    const breakdown: any = {
      openCount: incidents.filter(
        (x) =>
          x.incidentStatus == 0 &&
          new Date(x.eventCreateDate).toDateString() ===
            new Date().toDateString()
      ).length,
      closedCount: incidents.filter(
        (x) =>
          x.incidentStatus == 1 &&
          new Date(x.eventCreateDate).toDateString() ===
            new Date().toDateString()
      ).length,
      inProgressCount: incidents.filter(
        (x) =>
          x.incidentStatus == 4 &&
          new Date(x.eventCreateDate).toDateString() ===
            new Date().toDateString()
      ).length,
      completeCount: incidents.filter(
        (x) =>
          x.incidentStatus == 8 &&
          new Date(x.eventCreateDate).toDateString() ===
            new Date().toDateString()
      ).length,
      onHoldCount: incidents.filter(
        (x) =>
          x.incidentStatus == 5 &&
          new Date(x.eventCreateDate).toDateString() ===
            new Date().toDateString()
      ).length,
      approvedCount: incidents.filter(
        (x) =>
          x.incidentStatus == 6 &&
          new Date(x.eventCreateDate).toDateString() ===
            new Date().toDateString()
      ).length,
      rejectedCount: incidents.filter(
        (x) =>
          x.incidentStatus == 7 &&
          new Date(x.eventCreateDate).toDateString() ===
            new Date().toDateString()
      ).length,
      verifiedCount: incidents.filter(
        (x) =>
          x.incidentStatus == 2 &&
          new Date(x.eventCreateDate).toDateString() ===
            new Date().toDateString()
      ).length,
      snoozedCount: incidents.filter(
        (x) =>
          x.incidentStatus == 3 &&
          new Date(x.eventCreateDate).toDateString() ===
            new Date().toDateString()
      ).length,
      anprCount: incidents.filter(
        (x) =>
          x.incidentStatus == 0 &&
          new Date(x.eventCreateDate).toDateString() ===
            new Date().toDateString()
      ).length,
      intrusionCount: incidents.filter((x) => x.incidentName === 'Intrusion')
        .length,
      fireCount: incidents.filter((x) => x.incidentName === 'Fire').length,
      manualCount: incidents.filter((x) => x.incidentType == 'Manual').length,
      autoCount: incidents.filter((x) => x.incidentType != 'Manual').length,
      securityCallbacksCount: incidents.filter(
        (x) => x.incidentName == 'Security Callback'
      ).length,
      serviceRequestCount: incidents.filter(
        (x) => x.incidentName == 'Service Request'
      ).length,
      soSAlertsCount: incidents.filter((x) => x.incidentName == 'Advanced SOS')
        .length,
      systemFailureCount: incidents.filter(
        (x) => x.incidentName == 'APIFailure'
      ).length,
      deviceFailureCount: incidents.filter(
        (x) => x.incidentName == 'DeviceFailure'
      ).length,
      claimsCount: incidents.filter((x) => x.incidentName == 'Claim').length,
    };

    // Add the breakdown to the result array
    incidentBreakdownGraph = breakdown;
  });
  return incidentBreakdownGraph;
}
export function calculateRiskScore(
  incidents: IIncidents[]
): IncidentRiskScores {
  let riskScores = getMonthRiskData(incidents);
  return riskScores;
}
export function getMonthRiskData(
  incidentDetails: IIncidents[]
): IncidentRiskScores {
  const scoreData = new IncidentRiskScores();

  incidentDetails.forEach((item) => {
    let score = 0;
    score = calculateScore(item);
    if (item.incidentStatus === 7) {
      score = 0;
    }
    scoreData.riskScore += score;
    updateCategoryScores(scoreData, item, score);
    // if (item.incidentName.toLowerCase() === 'intrusion') {
    //   scoreData.intrusionScore += score;
    //   scoreData.intrusionCount++;
    // } else if (
    //   item.incidentName.toLowerCase() === 'manual' &&
    //   item.incidentCriticality.toLowerCase() === 'high'
    // ) {
    //   scoreData.manualScore += score;
    //   scoreData.manualCount++;
    // } else if (item.incidentName.toLowerCase() === 'fire') {
    //   scoreData.fireScore += score;
    //   scoreData.fireCount++;
    // } else if (item.incidentName.toLowerCase() === 'advanced sos') {
    //   scoreData.emergencySosScore += score;
    //   scoreData.emergencySosCount++;
    // }
  });

  return scoreData;
}
export function getRiskAnalyticsData(incidentData: IIncidents[]): IRiskData {
  const riskAnalyticsSingleDayData: RiskAnalyticsSingleDayData[] = [];
  const riskAnalyticsData: RiskAnalyticsData[] = [];
  const riskAnalyticsStatusData: RiskAnalyticsStatusData[] = [];

  const eventDates = [
    ...new Set(
      incidentData.map((x) => new Date(x.eventCreateDate).toDateString())
    ),
  ]
    .map((x) => new Date(x))
    .sort((a, b) => b.getTime() - a.getTime());

  const minDate = new Date(
    Math.min(...eventDates.map((date) => date.getTime()))
  );
  const maxDate = new Date(
    Math.max(...eventDates.map((date) => date.getTime()))
  );

  const allDates: Date[] = [];
  for (
    let date = new Date(minDate);
    date <= maxDate;
    date.setDate(date.getDate() + 1)
  ) {
    allDates.push(new Date(date));
  }

  const missingDates = allDates.filter(
    (d) => !eventDates.some((ed) => ed.getTime() === d.getTime())
  );
  eventDates.push(...missingDates);
  eventDates.sort((a, b) => b.getTime() - a.getTime());

  eventDates.forEach((eventDT) => {
    const selectedDateIncidents = incidentData.filter(
      (x) =>
        new Date(x.eventCreateDate).toDateString() === eventDT.toDateString()
    );

    const riskDataAnalytics: RiskAnalyticsData = {
      eventDate: eventDT,
      incidentCounts: selectedDateIncidents.length,
      riskTotalScores: 0,
    };

    const riskDataAnalyticsStatus: RiskAnalyticsStatusData = {
      eventDate: eventDT,
      open: selectedDateIncidents.filter((x) => x.incidentStatus === 0).length,
      closed: selectedDateIncidents.filter((x) => x.incidentStatus === 1)
        .length,
      verified: selectedDateIncidents.filter((x) => x.incidentStatus === 2)
        .length,
      snoozed: selectedDateIncidents.filter((x) => x.incidentStatus === 3)
        .length,
      inProgress: selectedDateIncidents.filter((x) => x.incidentStatus === 4)
        .length,
      onHold: selectedDateIncidents.filter((x) => x.incidentStatus === 5)
        .length,
      approved: selectedDateIncidents.filter((x) => x.incidentStatus === 6)
        .length,
      rejected: selectedDateIncidents.filter((x) => x.incidentStatus === 7)
        .length,
    };

    let totalScoreForDate = 0;

    selectedDateIncidents.forEach((item) => {
      let score = calculateScore(item);

      if (item.incidentStatus === 7) {
        score = 0;
      }

      totalScoreForDate += score;

      if (eventDT.toDateString() === new Date().toDateString()) {
        const tempData: RiskAnalyticsSingleDayData = {
          incidentId: item.incidentId,
          incidentName: item.incidentName,
          eventDate: eventDT,
          eventTime: new Date(item.eventCreateDate).toLocaleTimeString(),
          incidentScores: score,
        };
        riskAnalyticsSingleDayData.push(tempData);
      }
    });

    riskDataAnalytics.riskTotalScores = totalScoreForDate;
    riskAnalyticsData.push(riskDataAnalytics);
    riskAnalyticsStatusData.push(riskDataAnalyticsStatus);
  });

  return {
    riskAnalyticsData,
    riskAnalyticsStatusData,
    riskAnalyticsSingleDayData,
  };
}
export function getCriticalRiskHour(incidentDetails: IIncidents[]): number {
  // Create a timeslotCounts map, where keys are timeslot indices (0-11) and values are counts.
  const timeslotCounts: { [key: number]: number } = {};

  // Initialize the dictionary with 0 counts for each timeslot (0-11)
  for (let i = 0; i < 12; i++) {
    timeslotCounts[i] = 0;
  }

  // Iterate over each incident and increment the count for the respective timeslot
  incidentDetails.forEach((item) => {
    const hour = new Date(item.eventCreateDate).getHours(); // Get the hour from the incident's event create date
    const timeslot = Math.floor(hour / 2); // Determine the timeslot (0-11)
    timeslotCounts[timeslot]++;
  });

  // Find the timeslot with the maximum count
  const criticalTimeSlot = Object.keys(timeslotCounts)
    .map((key) => parseInt(key, 10)) // Convert the keys back to numbers
    .sort((a, b) => timeslotCounts[b] - timeslotCounts[a])[0]; // Sort by value in descending order and take the first

  return criticalTimeSlot; // Return the most critical timeslot
}
export function getMonthRiskStatusData(
  incidentDetails: IIncidents[]
): RiskAnalyticsStatusData[] {
  const riskAnalyticsStatusData: RiskAnalyticsStatusData[] = [];

  // Extract distinct event dates and sort them in descending order
  let eventDates = [
    ...new Set(
      incidentDetails.map((x) =>
        new Date(x.eventCreateDate).setHours(0, 0, 0, 0)
      )
    ),
  ];
  eventDates.sort((a, b) => b - a);

  const minDate = new Date(Math.min(...eventDates));
  const maxDate = new Date(Math.max(...eventDates));

  // Generate all dates between minDate and maxDate
  const allDates: Date[] = [];
  for (
    let date = new Date(minDate);
    date <= maxDate;
    date.setDate(date.getDate() + 1)
  ) {
    allDates.push(new Date(date));
  }

  // Find missing dates
  const missingDates = allDates.filter(
    (date) => !eventDates.includes(date.getTime())
  );

  // Add missing dates and sort all dates in descending order
  eventDates = [...eventDates, ...missingDates.map((d) => d.getTime())].sort(
    (a, b) => b - a
  );

  // Iterate over each event date and gather risk analytics data
  eventDates.forEach((eventDT) => {
    const eventDate = new Date(eventDT);
    const selectedDateIncidents = incidentDetails.filter(
      (x) => new Date(x.eventCreateDate).setHours(0, 0, 0, 0) === eventDT
    );

    const riskDataAnalyticsStatus: RiskAnalyticsStatusData = {
      eventDate: eventDate,
      open: selectedDateIncidents.filter((x) => x.incidentStatus === 0).length,
      closed: selectedDateIncidents.filter((x) => x.incidentStatus === 1)
        .length,
      verified: selectedDateIncidents.filter((x) => x.incidentStatus === 2)
        .length,
      snoozed: selectedDateIncidents.filter((x) => x.incidentStatus === 3)
        .length,
      inProgress: selectedDateIncidents.filter((x) => x.incidentStatus === 4)
        .length,
      onHold: selectedDateIncidents.filter((x) => x.incidentStatus === 5)
        .length,
      approved: selectedDateIncidents.filter((x) => x.incidentStatus === 6)
        .length,
      rejected: selectedDateIncidents.filter((x) => x.incidentStatus === 7)
        .length,
    };

    riskAnalyticsStatusData.push(riskDataAnalyticsStatus);
  });

  return riskAnalyticsStatusData;
}
export function getHeatMapIncidentData(
  incidents: IIncidents[]
): IncidentHeatMapGraph[] {
  // Create graph data based on the assets
  const graphData: IncidentHeatMapGraph[] = assets.map((asset) => {
    const assetLocation: StaticLocation = JSON.parse(asset.assetLocation)[0];
    return {
      assetId: asset.assetId,
      assetName: asset.assetName,
      assetLocation: asset.assetLocation,
      latitude: assetLocation.lat,
      longitude: assetLocation.lng,
      incidentCount: 0,
    };
  });
  // Update incident count for each asset in the graph data
  graphData.forEach((data) => {
    const assetIncidents = incidents.filter(
      (incident) =>
        incident.sourceAssetId &&
        incident.sourceAssetId.toLowerCase() === data.assetId.toLowerCase()
    );
    data.incidentCount = assetIncidents.length;
  });
  return graphData.filter((data) => data.incidentCount > 0);
}
export function getIncidentGraphData(incident: IIncidents): IncidentTimeline[] {
  const timeline: IncidentTimeline[] = [];

  // Helper function to convert time to decimal format
  const convertTimeToDecimal = (date: Date): number => {
    return Number(
      `${date.getHours()}.${date.getMinutes().toString().padStart(2, '0')}`
    );
  };

  // 0: Open status
  let openStatus = new Date(incident.eventCreateDate);
  let temp1: IncidentTimeline = {
    eventDate: openStatus,
    eventTime: convertTimeToDecimal(openStatus),
    status: 0, // Open
  };
  timeline.push(temp1);

  // Check for each event status and add to timeline if it exists
  if (incident.eventClosedDate) {
    let closeStatus = new Date(incident.eventClosedDate);
    temp1 = {
      eventDate: closeStatus,
      eventTime: convertTimeToDecimal(closeStatus),
      status: 1, // Close
    };
    timeline.push(temp1);
  }

  if (incident.eventVerifiedDate) {
    let verifiedStatus = incident.eventVerifiedDate;
    temp1 = {
      eventDate: verifiedStatus,
      eventTime: convertTimeToDecimal(verifiedStatus),
      status: 2, // Verified
    };
    timeline.push(temp1);
  }

  if (incident.eventSnoozedDate) {
    let snoozedStatus = incident.eventSnoozedDate;
    temp1 = {
      eventDate: snoozedStatus,
      eventTime: convertTimeToDecimal(snoozedStatus),
      status: 3, // Snoozed
    };
    timeline.push(temp1);
  }

  if (incident.eventInProgressDate) {
    let inProgressStatus = incident.eventInProgressDate;
    temp1 = {
      eventDate: inProgressStatus,
      eventTime: convertTimeToDecimal(inProgressStatus),
      status: 4, // In-Progress
    };
    timeline.push(temp1);
  }

  if (incident.eventOnHoldDate) {
    let onHoldStatus = incident.eventOnHoldDate;
    temp1 = {
      eventDate: onHoldStatus,
      eventTime: convertTimeToDecimal(onHoldStatus),
      status: 5, // On-Hold
    };
    timeline.push(temp1);
  }

  if (incident.eventApprovedDate) {
    let approvedStatus = incident.eventApprovedDate;
    temp1 = {
      eventDate: approvedStatus,
      eventTime: convertTimeToDecimal(approvedStatus),
      status: 6, // Approved
    };
    timeline.push(temp1);
  }

  if (incident.eventRejectedDate) {
    let rejectedStatus = incident.eventRejectedDate;
    temp1 = {
      eventDate: rejectedStatus,
      eventTime: convertTimeToDecimal(rejectedStatus),
      status: 7, // Rejected
    };
    timeline.push(temp1);
  }

  // Optionally sort timeline based on eventDate
  return timeline.sort((a, b) => a.eventDate.getTime() - b.eventDate.getTime());
}
export const jammuLocation: string[] = [
  '[{"label":"B-318/32 Kathua Sub-District, Jammu & Kashmir, India","countryCode":"IND","countryName":"India","stateCode":"JK","state":"Jammu & Kashmir","county":"Kathua","postalCode":"184143","city":"Kathua Sub-District","lat":32.41237,"lng":75.47252}]',
  '[{"label":"105, Shalamar-Ranbir Market, Resham Ghar Colony, Jammu 180001, India","countryCode":"IND","countryName":"India","stateCode":"JK","state":"Jammu & Kashmir","county":"Jammu","postalCode":"180001","city":"Jammu","lat":32.73201,"lng":74.86199}]',
  '[{"label":"8 Rama Lane, Bhagwati Nagar-Ward No 23, Talab Tillo, Jammu 180002, India","countryCode":"IND","countryName":"India","stateCode":"JK","state":"Jammu & Kashmir","county":"Jammu","postalCode":"180002","city":"Jammu","lat":32.72916,"lng":74.83988}]',
  '[{"label":"816 east a, extension near 3, Jindal Enterprises, Ambphalla-Kacchi Chawni, Old Heritage City, Jammu 180001, India","countryCode":"IND","countryName":"India","stateCode":"JK","state":"Jammu & Kashmir","county":"Jammu","postalCode":"180001","city":"Jammu","lat":32.73969,"lng":74.8655}]',
  '[{"label":"Leather Work, Baghyas Mohalla, Chhatabal, Srinagar 190010, India","countryCode":"IND","countryName":"India","stateCode":"JK","state":"Jammu & Kashmir","county":"Srinagar","postalCode":"190010","city":"Srinagar","lat":34.08719,"lng":74.78869}]',
  '[{"label":"Waseem, Habba Kadal, Srinagar 190001, India","countryCode":"IND","countryName":"India","stateCode":"JK","state":"Jammu & Kashmir","county":"Srinagar","postalCode":"190001","city":"Srinagar","lat":34.08382,"lng":74.81105}]',
  '[{"label":"Shalimar Park, Katra 182320, India","countryCode":"IND","countryName":"India","stateCode":"JK","state":"Jammu & Kashmir","county":"Reasi","postalCode":"182320","city":"Katra","lat":32.99616,"lng":74.93815}]',
];

export function getOrgProperties(): IProperty[] {
  let propertyNames: string[] = ['Jammu', 'Srinagar', 'Katra', 'Rajouri'];
  let propertyLocation: string[] = [
    '[{"label":"23, Prem Nagar, Old Heritage City, Jammu 180016, India","countryCode":"IND","countryName":"India","stateCode":"JK","state":"Jammu & Kashmir","county":"Jammu","postalCode":"180016","city":"Jammu","lat":32.7228,"lng":74.85796}]',
    '[{"label":"RN Temple, Kani Kadal, Srinagar 190002, India","countryCode":"IND","countryName":"India","stateCode":"JK","state":"Jammu & Kashmir","county":"Srinagar","postalCode":"190002","city":"Srinagar","lat":34.08569,"lng":74.80537}]',
    '[{"label":"Damni Tour and Travels, Katra 182301, India","countryCode":"IND","countryName":"India","stateCode":"JK","state":"Jammu & Kashmir","county":"Reasi","postalCode":"182301","city":"Katra","lat":32.99225,"lng":74.9311}]',
    '[{"label":"MS Dalogra, Rajauri 185131, India","countryCode":"IND","countryName":"India","stateCode":"JK","state":"Jammu & Kashmir","county":"Rajauri","postalCode":"185131","city":"Rajauri","lat":33.37164,"lng":74.31512}]',
  ];
  let property: IProperty[] = [];
  for (let i = 0; i < propertyNames.length; i++) {
    let propid = uuidv4();
    let propAssets: IAssets[] = getPropertyAssets(
      i == 0 ? 3 : i == 1 ? 2 : i == 3 ? 1 : 2,
      propertyNames[i],
      propid
    );
    let temp: IProperty = {
      propId: propid,
      propName: propertyNames[i],
      propType: 'Building',
      propLocation: propertyLocation[i],
      propCreateDate: new Date().toISOString(),
      totalAssets: propAssets.length,
      assetDetails: propAssets,
    };
    property.push(temp);
  }
  return property;
}
function getPropertyAssets(
  n: number,
  location: string,
  propId: string
): IAssets[] {
  let assets: IAssets[] = [];
  let assetLocation: string[] = [];
  assetLocation = jammuLocation;
  // if (location == 'Jammu'){

  // }else if(location =='Srinagar'){
  //   assetLocation = srinagarLocation;
  // }else if(location =='Katra'){
  //   assetLocation = katraLocation;
  // }else{
  //   assetLocation = rajouriLocation;
  // }
  for (let i = 0; i < n; i++) {
    let asset: IAssets = {
      propId: propId,
      assetId: uuidv4(),
      assetName: `Police Station ${generateRandomNumber(10)}`,
      assetType: 'Room',
      assetUrl: '',
      assetUrlPlaylist: '',
      assetLocation:
        assetLocation[generateRandomNumber(assetLocation.length - 1)],
      assetCreateDate: new Date().toISOString(),
      assetRemoveDate: null,
      computerVision: null,
      intrusion: null,
      peopleDetection: null,
      animalDetection: null,
      vehicleDetection: null,
      anpr: null,
      fire: null,
      faceRecognization: null,
      settingCreateDate: null,
      settingCreateDateBy: null,
      settingUpdateDate: null,
      settingUpdateBy: null,
      settingMode: null,
      assetFrame: null,
      frameHeight: null,
      frameWidth: null,
      assetFrameMobile: null,
      frameHeightMobile: null,
      frameWidthMobile: null,
    };

    assets.push(asset);
  }

  return assets;
}
export function getServiceRequest(
  requestType: string,
  requestDesc: string
): ComplaintsTickets {
  const orgId = localStorage.getItem('OrganizationId');
  let user: UserRegDetails =
    orgUsers[generateRandomNumber(orgUsers.length - 1)];
  let incident: IIncidents = CreateManualIncident(
    requestType,
    requestDesc,
    'Medium'
  );
  let serviceRequest: ComplaintsTickets = {
    orgId: orgId,
    complainId: uuidv4(),
    assignedAdminId: user.userId,
    complainSubject: requestType,
    complainDescription: requestDesc,
    complainStatus: '0',
    mode: true,
    complainAddDate: new Date(),
    complainResolvedDate: null,
    complainRemovedDate: null,
    complainIncidentDetails: incident,
    evidence: null,
  };
  return serviceRequest;
}
export function getOrgUsers(): UserRegDetails[] {
  let users: UserRegDetails[] = orgUsers;
  return users;
}

export function getNonAssetIncidentsData(
  incidents: IIncidents[]
): IncidentHeatMapGraph[] {
  const graphData: IncidentHeatMapGraph[] = [];

  incidents.forEach((incident) => {
    // Check if the incident is linked to an asset by sourceAssetId
    if (incident.sourceAssetId) {
      const assetIncident = graphData.find(
        (x) => x.assetId === incident.sourceAssetId
      );
      if (assetIncident) {
        assetIncident.incidentCount += 1;
      }
    } else if (
      incident.incidentLocation &&
      incident.incidentLocation.length > 1
    ) {
      // Handle cases where incident is not linked to an asset but has a location
      try {
        const incidentLocation: StaticLocation[] = JSON.parse(
          incident.incidentLocation
        );
        if (incidentLocation && incidentLocation.length > 0) {
          const loc = incidentLocation[0];
          const existingLocation = graphData.find(
            (x) => x.latitude === loc.lat && x.longitude === loc.lng
          );

          if (existingLocation) {
            existingLocation.incidentCount += 1;
          } else {
            const nonAssetIncident: IncidentHeatMapGraph = {
              assetId: 'NonAsset',
              assetName: 'Manual Incidents',
              assetLocation: incident.incidentLocation,
              latitude: loc.lat,
              longitude: loc.lng,
              incidentCount: 1,
            };
            graphData.push(nonAssetIncident);
          }
        }
      } catch (error) {
        // Handle JSON parse error or any other logic needed
      }
    }
  });
  return graphData;
}
function calculateScore(item: IIncidents): number {
  let score = 0;
  if (item.eventDurationMinutes) {
    const minutes = parseFloat(item.eventDurationMinutes);

    if (minutes <= 60) score = 25;
    else if (minutes > 60 && minutes <= 720) score = 50;
    else if (minutes > 720 && minutes <= 1440) score = 100;
    else if (minutes > 1440 && minutes <= 10080) score = 200;
    else if (minutes > 10080) score = 500;
  } else {
    const minutes = Math.floor(
      (new Date().getTime() - new Date(item.eventCreateDate).getTime()) / 60000
    );

    if (minutes <= 60) score = 25;
    else if (minutes > 60 && minutes <= 720) score = 50;
    else if (minutes > 720 && minutes <= 1440) score = 100;
    else if (minutes > 1440 && minutes <= 10080) score = 200;
    else if (minutes > 10080) score = 500;
  }

  return score;
}
function updateCategoryScores(
  scoreData: IncidentRiskScores,
  item: IIncidents,
  score: number
): void {
  if (item.incidentName.toLowerCase() === 'intrusion') {
    scoreData.intrusionScore += score;
    scoreData.intrusionCount++;
  } else if (
    item.incidentType.toLowerCase() === 'manual' &&
    item.incidentCriticality.toLowerCase() === 'high'
  ) {
    scoreData.manualScore += score;
    scoreData.manualCount++;
  } else if (item.incidentName.toLowerCase() === 'fire') {
    scoreData.fireScore += score;
    scoreData.fireCount++;
  } else if (item.incidentName.toLowerCase() === 'advanced sos') {
    scoreData.emergencySosScore += score;
    scoreData.emergencySosCount++;
  }
  let riskData: any[] = JSON.parse(localStorage.getItem('Risks'));
  const CriticalIncidents = riskData
    .filter((risk) => risk.riskCriticality == '100')
    .map((risk) => risk.riskQuestion);
  const MediumIncidents = riskData
    .filter((risk) => risk.riskCriticality == '50')
    .map((risk) => risk.riskQuestion);
  const LowNoIncidents = riskData
    .filter(
      (risk) => risk.riskCriticality == '0' || risk.riskCriticality == '25'
    )
    .map((risk) => risk.riskQuestion);
  if (
    CriticalIncidents.some(
      (ci) => ci.toLowerCase() === item.incidentName.toLowerCase()
    )
  ) {
    scoreData.highScore += score;
    scoreData.highCount++;
  }
  if (
    MediumIncidents.some(
      (ci) => ci.toLowerCase() === item.incidentName.toLowerCase()
    )
  ) {
    scoreData.mediumScore += score;
    scoreData.mediumCount++;
  } else {
    scoreData.lowScore += score;
    scoreData.lowCount++;
  }
}
export interface IAnalyticsData {
  riskQuestions: IRiskQuestions[];
  riskAnalyticsGraph: IRiskGraph[];
  riskAnalyticsPreviousMonthGraph: IRiskGraph[];
  riskSingleAnalyticsGraph: IRiskSingleGraph[];
  averageCloseTime: any;
  criticalIncidentsCounts: any;
  criticalIncidentsCountNumber: any;
  currentMonthRiskScore: number;
  previousMonthRiskScore: number;
  criticalRiskHour: number;
  hotCheckInSlot: number;
  monthlyVisitorBarGraph: any;
  monthlyVisitorInOutGraph: any;
  riskHeatMapData: any;
  riskAnalyticsStatusGraph: any;
  uniqueVisitors: number;
  currentDayVisitors: number;
  currentMonthClaimTotal: number;
  previousMonthClaimTotal: number;
  currentMonthClaimAmount: number;
  previousMonthClaimAmount: number;
}
export interface ILocation {
  label: string;
  countryCode: string;
  countryName: string;
  stateCode: string;
  state: string;
  county: string;
  postalCode: string;
  city: string;
  lat: number;
  lng: number;
}
export class IncidentRiskScores {
  riskScore: number = 0;
  intrusionCount: number = 0;
  intrusionScore: number = 0;

  highCount: number = 0;
  highScore: number = 0;
  mediumCount: number = 0;
  mediumScore: number = 0;
  lowCount: number = 0;
  lowScore: number = 0;

  manualCount: number = 0;
  manualScore: number = 0;
  fireCount: number = 0;
  fireScore: number = 0;
  emergencySosCount: number = 0;
  emergencySosScore: number = 0;
  totalCloseTime: number = 0;
}
export interface RiskAnalyticsData {
  eventDate: Date;
  incidentCounts: number;
  riskTotalScores: number;
}
export interface RiskAnalyticsStatusData {
  eventDate: Date;
  open: number;
  closed: number;
  verified: number;
  snoozed: number;
  inProgress: number;
  onHold: number;
  approved: number;
  rejected: number;
}
export interface RiskAnalyticsSingleDayData {
  incidentId: string;
  incidentName: string;
  eventDate: Date;
  eventTime: string;
  incidentScores: number;
}
export interface IRiskData {
  riskAnalyticsData: RiskAnalyticsData[];
  riskAnalyticsStatusData: RiskAnalyticsStatusData[];
  riskAnalyticsSingleDayData: RiskAnalyticsSingleDayData[];
}
export interface IncidentHeatMapGraph {
  assetId: string;
  assetName: string;
  assetLocation: string;
  latitude: number;
  longitude: number;
  incidentCount: number;
}
export interface StaticLocation {
  lat: number;
  lng: number;
}
export interface IncidentTimeline {
  eventDate: Date;
  eventTime: number; // Time as decimal (e.g., 13.30 for 1:30 PM)
  status: number; // 0: 'Open', 1: 'Close', etc.
}
